import { ProjectListDataProp } from "../../Types/Project.type";

export const allProjectListData: ProjectListDataProp[] = [
    {
        id: 1,
        title: "Endless admin Design",
        badge: "Doing",
        image: "user/3.jpg",
        sites: "Themeforest, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "12",
        resolved: "5",
        comment: "7",
        like: "10",
        progress: "70",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    },
    {
        id: 2,
        title: "Universal admin Design",
        badge: "Done",
        image: "user/3.jpg",
        sites: "Envato, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "24",
        resolved: "24",
        comment: "40",
        like: "3",
        progress: "100",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    },
    {
        id: 3,
        title: "Poco admin Design",
        badge: "Done",
        image: "user/3.jpg",
        sites: "Envato, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "40",
        resolved: "40",
        comment: "20",
        like: "2",
        progress: "100",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    },
    {
        id: 4,
        title: "Universal admin Design",
        badge: "Done",
        image: "user/3.jpg",
        sites: "Envato, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "24",
        resolved: "24",
        comment: "40",
        like: "3",
        progress: "100",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    },
    {
        id: 5,
        title: "Endless admin Design",
        badge: "Doing",
        image: "user/3.jpg",
        sites: "Themeforest, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "12",
        resolved: "5",
        comment: "7",
        like: "10",
        progress: "70",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    },
    {
        id: 6,
        title: "Poco admin Design",
        badge: "Done",
        image: "user/3.jpg",
        sites: "Envato, australia",
        description: "Users have a significant influence on how well-functioning and successful different software and internet services are.",
        issue: "40",
        resolved: "40",
        comment: "20",
        like: "2",
        progress: "100",
        customer1: "user/3.jpg",
        customer2: "user/5.jpg",
        customer3: "user/1.jpg"
    }
]